import { render, staticRenderFns } from "./CustomerFilesDisplay.vue?vue&type=template&id=5b08ae81&scoped=true&"
import script from "./CustomerFilesDisplay.vue?vue&type=script&lang=js&"
export * from "./CustomerFilesDisplay.vue?vue&type=script&lang=js&"
import style0 from "./CustomerFilesDisplay.vue?vue&type=style&index=0&id=5b08ae81&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b08ae81",
  null
  
)

export default component.exports